var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47798 3.80458H15.3068L13.3108 5.8006L2.47781 5.80044C2.47228 5.80044 2.46776 5.80496 2.46776 5.81048V21.2352C2.46776 21.2407 2.47228 21.2452 2.47781 21.2452H17.9025C17.9081 21.2452 17.9126 21.2407 17.9126 21.2352V11.4762L19.9086 9.48017V21.2354C19.9086 22.3387 19.006 23.2415 17.9025 23.2415L2.47778 23.2414C1.37455 23.2414 0.47168 22.3387 0.47168 21.2353L0.471847 5.811C0.472014 4.70777 1.37451 3.80507 2.47778 3.80507L2.47798 3.80458ZM10.6461 13.6039C9.96744 12.9252 9.16807 12.4906 8.41186 12.3294L8.33485 12.4064L7.6103 16.6397L11.8436 15.9151L11.9206 15.8381C11.7592 15.0819 11.3245 14.2827 10.6461 13.6039ZM20.5011 0.855579C20.3317 0.686161 20.0548 0.686161 19.8854 0.855579L18.4462 2.29481L21.9546 5.80322L23.3938 4.36399C23.5632 4.19457 23.5632 3.91768 23.3938 3.74826L20.5011 0.855579ZM21.14 6.61815L17.6314 3.10956L9.33851 11.4024C10.1356 11.6982 10.8644 12.1924 11.4608 12.7888C12.0571 13.3851 12.5513 14.1143 12.8471 14.911L21.14 6.61815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/EditButton.95f86827b8007bdda61fa26abfd3b8aa.svg";
export { ForwardRef as ReactComponent };